import BaseStore from "@/stateManagement/BaseStore";
import {
    CustomerAttributesEntity,
    ProductAttributesEntity,
} from "@apps/reviews/entities/AttributesEntity";
import { StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

export interface AttributesState {
    attributes: {
        customerAttributes: CustomerAttributesEntity;
        productAttributes: ProductAttributesEntity;
    };
}

const createInitialState = (): AttributesState => {
    return {
        attributes: {
            customerAttributes: [],
            productAttributes: [],
        },
    };
};

@injectable()
@StoreConfig({ name: "attributes", resettable: true })
export default class AttributesStore extends BaseStore<AttributesState> {
    constructor() {
        super(createInitialState());
    }
}
